import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './mui-license';
import { loadServerIdentity, purgeLegacyStaffFlag } from './auth/serverIdentity';

const root = ReactDOM.createRoot(document.getElementById('root'));
const renderApp = () => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

// The staff flag comes from the server (GET conductor/get-current-user), never from browser storage.
purgeLegacyStaffFlag();
if (localStorage.getItem('token')) {
  loadServerIdentity().catch(() => false).finally(renderApp);
} else {
  renderApp();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
